import React, { useState, useEffect, useRef } from "react";
import "./ProfileMarketPosition.css";
import { useDispatch, useSelector } from "react-redux";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import { useParams, useSearchParams } from "react-router-dom";
import {
  submitCompetitorProfileFailure,
  submitCompetitorProfileRequest,
} from "../../../../../store/features/actions/competitorProfileActions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
  formatBoldText,
  getCompProfilePageInsights,
  hasData,
} from "../../../../../services/commonService";
import KeyExpansions from "./KeyExpansions";
import InsightBlock from "../../InsightBlock";
import KeyInitiatives from "./KeyInitiatives";
import TrendingIndustrySegments from "./TrendingIndustrySegments";
import CustomerSegmentsAndUseCases from "./CustomerSegmentsAndUseCases";
import TrendingCompetitors from "./TrendingCompetitors";
import TopRightActionLinks from "../../TopRightActionLinks";
import PrimaryMarket from "./PrimaryMarket";
import SubMarket from "./SubMarket";
import ApplicationMarket from "./ApplicationMarket";
import MarketShareAnalysis from "./MarketShareAnalysis";
import CustomerSegmentAnalysis from "./CustomerSegmentAnalysis";
import KeyExpansionsAndStrategicInitiatives from "./KeyExpansionsAndStrategicInitiatives";
import MarketByTechnology from "./MarketByTechnology";
import MarketPositionByGeography from "./MarketPositionByGeography";
import MarketPositionByApplication from "./MarketPositionByApplication";
import { submitCompetitorProfileV1Request } from "../../../../../store/features/actions/competitorProfileV1Actions";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";

function ProfileMarketPosition({
  activeSubKey,
  setActiveSubKey,
  compView,
  dataReportCheck,
  scrollTarget,
}) {
  const summaryRef = useRef(null);
  const technologyRef = useRef(null);
  const geographyRef = useRef(null);
  const applicationRef = useRef(null);
  const marketShareRef = useRef(null);
  const customerSegmentRef = useRef(null);
  const keyExpansionsStrategicRef = useRef(null);
  const programmaticScrollRef = useRef(false);

  const sectionMap = {
    insightSummaryTabMp: summaryRef,
    marketByTechnologyTab: technologyRef,
    marketByGeographyTab: geographyRef,
    marketByApplicationTab: applicationRef,
    marketShareAnalysisTab: marketShareRef,
    customerSegmentAnalysisTab: customerSegmentRef,
    keyExpansionsStrategicInitiativesTab: keyExpansionsStrategicRef,
  };

  const scrollToSection = (key) => {
    const ref = sectionMap[key];
    if (!ref?.current) return;

    programmaticScrollRef.current = true;

    const yOffset = -100;
    const y =
      ref.current.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });

    setTimeout(() => {
      programmaticScrollRef.current = false;
    }, 700);
  };

  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [allPosNegSo, setAllPosNegSo] = useState([]);
  const [marketByTechnology, setMarketByTechnology] = useState([]);
  const [marketByGeography, setMarketByGeography] = useState([]);
  const [marketByApplication, setMarketByApplication] = useState([]);
  const [primaryMarket, setPrimaryMarket] = useState([]);
  const [subMarket, setSubMarket] = useState([]);
  const [applicationMarket, setApplicationMarket] = useState([]);
  const [marketShareAnalysis, setMarketShareAnalysis] = useState([]);
  const [customerSegmentAnalysis, setCustomerSegmentAnalysis] = useState([]);
  const [
    keyExpansionsStrategicInitiatives,
    setKeyExpansionsStrategicInitiatives,
  ] = useState([]);
  const [isInsightOn, setIsOn] = useState(false);
  const { clientName, competitorName } = useParams();
  const [marketPositionDataCheck, setMarketPositionDataCheck] = useState({
    hasInsightSummaryTabMpData: true,
    hasMarketByTechnologyTabData: true,
    hasMarketByApplicationTabData: true,
    hasMarketByGeographyTabData: true,
    hasMarketShareAnalysisTabData: true,
    hasCustomerSegmentAnalysisTabData: true,
    hasKeyExpansionsStrategicInitiativesTabData: true,
  });

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  // const { loading, data, error } = useSelector(
  //   (state) => state.competitorProfileReducer
  // );

  const dispatch = useDispatch();
  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  const v1Data = useSelector((state) => state.competitorProfileV1Reducer);
  const formData = {
    dimension: "MarketPosition",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
  };

  // Scroll into view when a subsection tab is clicked
  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     insightSummaryTabMp: summaryRef,
  //     marketByTechnologyTab: technologyRef,
  //     marketByGeographyTab: geographyRef,
  //     marketByApplicationTab: applicationRef,
  //     marketShareAnalysisTab: marketShareRef,
  //     customerSegmentAnalysisTab: customerSegmentRef,
  //     keyExpansionsStrategicInitiativesTab: keyExpansionsStrategicRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  useEffect(() => {
    let scrollTimeout = null;
    let ticking = false;

    const handleScroll = () => {
      if (programmaticScrollRef.current) return; // ignore programmatic scrolls
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        // Clear previous timeout (debounce)
        if (scrollTimeout) clearTimeout(scrollTimeout);

        // Wait until user stops scrolling for 200ms
        scrollTimeout = setTimeout(() => {
          const scrollPosition = window.scrollY + 120; // offset for header, etc.
          let currentKey = null;

          Object.entries(sectionMap).forEach(([key, ref]) => {
            if (!ref.current) return;
            const sectionTop = ref.current.offsetTop;
            const sectionHeight = ref.current.offsetHeight;

            // Check if scroll is within this section
            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              currentKey = key;
            }
          });

          // update nav only if different
          if (currentKey && currentKey !== activeSubKey) {
            setActiveSubKey(currentKey);
          }
        }, 200); // change nav only after 200ms of no scrolling

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // run once on mount
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    // dispatch(submitCompetitorProfileRequest("MarketPosition"));
    // dispatch(submitCompetitorProfileV1Request("MarketPosition"));
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);

  useEffect(() => {
    const tempMarketByTechnology = getAllSubdimensionMatches(
      data,
      "Market by Technology"
    );
    setMarketByTechnology(tempMarketByTechnology);

    const tempMarketByGeography = getAllSubdimensionMatches(
      data,
      "Market by Geography"
    );
    setMarketByGeography(tempMarketByGeography);

    const tempMarketByApplication = getAllSubdimensionMatches(
      data,
      "Market by application"
    );
    setMarketByApplication(tempMarketByApplication);

    // const tempPrimaryMarket = getAllSubdimensionMatches(
    //   data,
    //   "Primary Markets"
    // );
    // setPrimaryMarket(tempPrimaryMarket);

    // const tempSubMarket = getAllSubdimensionMatches(data, "Sub-Markets");
    // setSubMarket(tempSubMarket);
    // const tempApplicationMarket = getAllSubdimensionMatches(
    //   data,
    //   "Application Markets"
    // );
    // setApplicationMarket(tempApplicationMarket);

    const tempMarketShareAnalysis = getAllSubdimensionMatches(
      data,
      "Market Share Analysis"
    );
    setMarketShareAnalysis(tempMarketShareAnalysis);

    const tempCustomerSegmentAnalysis = getAllSubdimensionMatches(
      data,
      "Customer Segment Analysis"
    );
    setCustomerSegmentAnalysis(tempCustomerSegmentAnalysis);

    const tempKeyExpansionsStrategicInitiatives = getAllSubdimensionMatches(
      data,
      "Key Expansions & Strategic Initiatives"
    );
    setKeyExpansionsStrategicInitiatives(tempKeyExpansionsStrategicInitiatives);

    const tempPosNegSo = getAllSubdimensionMatches(data, "Strategic Analysis");
    const { positive, negative, sowhat } = getCompProfilePageInsights(data);

    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE

    const newCheck = {
      hasInsightSummaryTabMpData:
        hasData(positive) || hasData(negative) || hasData(sowhat),
      hasMarketByTechnologyTabData: hasData(tempMarketByTechnology),
      hasMarketByApplicationTabData: hasData(tempMarketByApplication),
      hasMarketByGeographyTabData: hasData(tempMarketByGeography),
      hasMarketShareAnalysisTabData: hasData(tempMarketShareAnalysis),
      hasCustomerSegmentAnalysisTabData: hasData(tempCustomerSegmentAnalysis),
      hasKeyExpansionsStrategicInitiativesTabData: hasData(
        tempKeyExpansionsStrategicInitiatives
      ),
    };

    // 4. Update the state once
    setMarketPositionDataCheck(newCheck);

    // 5. Notify the parent (Tabs) using the FRESH values
    dataReportCheck("insightSummaryTabMp", newCheck.hasInsightSummaryTabMpData);
    dataReportCheck(
      "marketByTechnologyTab",
      newCheck.hasMarketByTechnologyTabData
    );
    dataReportCheck(
      "marketByApplicationTab",
      newCheck.hasMarketByApplicationTabData
    );
    dataReportCheck(
      "marketByGeographyTab",
      newCheck.hasMarketByGeographyTabData
    );
    dataReportCheck(
      "marketShareAnalysisTab",
      newCheck.hasMarketShareAnalysisTabData
    );
    dataReportCheck(
      "customerSegmentAnalysisTab",
      newCheck.hasCustomerSegmentAnalysisTabData
    );
    dataReportCheck(
      "keyExpansionsStrategicInitiativesTab",
      newCheck.hasKeyExpansionsStrategicInitiativesTabData
    );

    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInsightSummaryTabMpData: !!(positive || negative || sowhat),
    // }));
    // dataReportCheck(
    //   "insightSummaryTabMp",
    //   !!(positive?.length || negative?.length || sowhat?.length)
    //   // marketPositionDataCheck.hasInsightSummaryTabMpData
    // );

    // const hasMbtData =
    //   (Array.isArray(tempMarketByTechnology) &&
    //     tempMarketByTechnology.length > 0) ||
    //   (typeof tempMarketByTechnology === "object" &&
    //     tempMarketByTechnology !== null &&
    //     Object.keys(tempMarketByTechnology).length > 0);
    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketByTechnologyTabData: hasMbtData,
    // }));
    // dataReportCheck("marketByTechnologyTab", hasMbtData);

    // const hasMbaData =
    //   (Array.isArray(tempMarketByApplication) &&
    //     tempMarketByApplication.length > 0) ||
    //   (typeof tempMarketByApplication === "object" &&
    //     tempMarketByApplication !== null &&
    //     Object.keys(tempMarketByApplication).length > 0);
    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketByApplicationTabData: hasMbaData,
    // }));
    // dataReportCheck("marketByApplicationTab", hasMbaData);

    // const hasMbgData =
    //   (Array.isArray(tempMarketByGeography) &&
    //     tempMarketByGeography.length > 0) ||
    //   (typeof tempMarketByGeography === "object" &&
    //     tempMarketByGeography !== null &&
    //     Object.keys(tempMarketByGeography).length > 0);

    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketByGeographyTabData: hasMbgData,
    // }));
    // dataReportCheck("marketByGeographyTab", hasMbgData);
    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasMarketShareAnalysisTabData: tempMarketShareAnalysis?.length
    //     ? !!tempMarketShareAnalysis
    //     : false,
    // }));
    // dataReportCheck(
    //   "marketShareAnalysisTab",
    //   tempMarketShareAnalysis?.length ? !!tempMarketShareAnalysis : false
    //   // marketPositionDataCheck.hasMarketShareAnalysisTabData
    // );

    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasCustomerSegmentAnalysisTabData: tempCustomerSegmentAnalysis?.length
    //     ? !!tempCustomerSegmentAnalysis
    //     : false,
    // }));
    // dataReportCheck(
    //   "customerSegmentAnalysisTab",
    //   tempCustomerSegmentAnalysis?.length
    //     ? !!tempCustomerSegmentAnalysis
    //     : false
    //   // marketPositionDataCheck.hasCustomerSegmentAnalysisTabData
    // );

    // setMarketPositionDataCheck((prevState) => ({
    //   ...prevState,
    //   hasKeyExpansionsStrategicInitiativesTabData:
    //     tempKeyExpansionsStrategicInitiatives?.length
    //       ? !!tempKeyExpansionsStrategicInitiatives
    //       : false,
    // }));
    // dataReportCheck(
    //   "keyExpansionsStrategicInitiativesTab",
    //   tempKeyExpansionsStrategicInitiatives?.length
    //     ? !!tempKeyExpansionsStrategicInitiatives
    //     : false
    //   // marketPositionDataCheck.hasKeyExpansionsStrategicInitiativesTabData
    // );

    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }, [data]);

  // useEffect(() => {
  //   const tempMarketShareAnalysis = getAllSubdimensionMatches(
  //     v1Data?.data,
  //     "Market Share Analysis"
  //   );
  //   setMarketShareAnalysis(tempMarketShareAnalysis);
  // }, [v1Data]);

  // const dummyGraphData = {
  //   data_set: [
  //     {
  //       segment_name: "Artificial Intelligence",
  //       market_size: 120,
  //       cagr: 18,
  //       bubble_color: "#4CAF50",
  //     },
  //     {
  //       segment_name: "Cloud Computing",
  //       market_size: 200,
  //       cagr: 15,
  //       bubble_color: "#2196F3",
  //     },
  //     {
  //       segment_name: "5G Technology",
  //       market_size: 90,
  //       cagr: 22,
  //       bubble_color: "#FF9800",
  //     },
  //     {
  //       segment_name: "Green Energy",
  //       market_size: 150,
  //       cagr: 12,
  //       bubble_color: "#9C27B0",
  //     },
  //     {
  //       segment_name: "Blockchain",
  //       market_size: 60,
  //       cagr: 25,
  //       bubble_color: "#F44336",
  //     },
  //   ],
  // };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (loading) {
  //     console.log("⏳ Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1200); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, loading]); // ADD staticDataLoading to deps

  useEffect(() => {
    if (!scrollTarget || loading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900); // wait for skeleton + render

    return () => clearTimeout(timer);
  }, [scrollTarget, loading]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="market_position_wrapper">
      <div className="market_position_headblock">
        <div className="market_position_subheadblock">
          <h5 className="market_position_head">
            Market Position & Customer Intelligence -{" "}
            {competitorName ?? "Tailored Chemical Products"}
          </h5>
          <p className="market_position_para">
            A focused view on where{" "}
            {competitorName ?? "Tailored Chemical Products"} is gaining or
            losing in the market, why, and what actionable insights matter most
            to {clientName ?? "HB Fuller"}.
          </p>
        </div>
        <div className="market_position_btn_block">
          <label className="toggle-switch toggle_custom_insight d-none">
            <input
              type="checkbox"
              checked={isInsightOn}
              onChange={() => setIsOn(!isInsightOn)}
              className="toggle_input_insight"
            />
            <span className="slider toggle_custom_slider"></span>
            <span className="label toggle_custom_lable">Insights</span>
          </label>

          <TopRightActionLinks actions={actions} />
        </div>
      </div>

      {marketPositionDataCheck.hasInsightSummaryTabMpData && (
        <div ref={summaryRef}>
          <InsightBlock
            title={"Insight Summary Profile Market Position"}
            overview={""}
            actions={[]}
            pagePositives={pagePositives}
            pageNegatives={pageNegatives}
            pageSoWhat={pageSoWhat}
          />
        </div>
      )}

      {/* <div>
        <MarketByTechnologyBubbleChart
          graph_id="techBubbleChart"
          graph_data={dummyGraphData}
          graph_height={500}
        />
      </div> */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasMarketByTechnologyTabData && (
          <div ref={technologyRef}>
            <MarketByTechnology
              marketByTechnology={marketByTechnology}
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasMarketByTechnologyTabData && (
          <div ref={applicationRef}>
            <MarketPositionByApplication
              marketByApplication={marketByApplication}
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasMarketByGeographyTabData && (
          <div ref={geographyRef}>
            <MarketPositionByGeography
              marketByGeography={marketByGeography}
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {/* <PrimaryMarket primaryMarket={primaryMarket} /> */}
      {/* <SubMarket subMarket={subMarket} /> */}
      {/* <ApplicationMarket applicationMarket={applicationMarket} /> */}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasMarketShareAnalysisTabData && (
          <div ref={marketShareRef}>
            <MarketShareAnalysis
              marketShareAnalysis={marketShareAnalysis}
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasCustomerSegmentAnalysisTabData && (
          <div ref={customerSegmentRef}>
            <CustomerSegmentAnalysis
              customerSegmentAnalysis={customerSegmentAnalysis}
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        marketPositionDataCheck.hasKeyExpansionsStrategicInitiativesTabData && (
          <div ref={keyExpansionsStrategicRef}>
            <KeyExpansionsAndStrategicInitiatives
              keyExpansionsStrategicInitiatives={
                keyExpansionsStrategicInitiatives
              }
              isInsightOn={isInsightOn}
              compView={compView}
            />
          </div>
        )
      )}

      {/* <KeyExpansions />
      <KeyInitiatives />
      <TrendingIndustrySegments /> */}
      {/* <div className="recent_customerwin_wrapper mb-2">
        <div className="recent_customerwin_headblock">
          <div className="recent_customerwin_subheadblock">
            <h5 className="recent_customerwin_head">
              Recent Strategic Customer Wins
            </h5>
            <p className="recent_customerwin_para">
              Key customers that drive significant revenue or strategic
              expansion for {competitorName ?? 'Tailored Chemical Products'}, based on recent partnership announcements
              and GPO agreements.
            </p>
          </div>
          <div className="recent_customerwin_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="recent_customerwin_subblock">
              <h5 className="recent_customerwin_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="recent_customerwin_para">
                Signed a prime vendor agreement covering multiple member
                organizations, including pediatric hospice; {competitorName ?? 'Tailored Chemical Products'} to supply
                clinical kits and products
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_yellow">
                    Hospice / Post-Acute
                  </a>
                </div>
                <div className="comp_bottom_left">
                  <p className="comp_text_para">2025</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="recent_customerwin_subblock">
              <h5 className="recent_customerwin_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="recent_customerwin_para">
                Signed a prime vendor agreement covering multiple member
                organizations, including pediatric hospice; {competitorName ?? 'Tailored Chemical Products'} to supply
                clinical kits and products
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_yellow">
                    Hospice / Post-Acute
                  </a>
                </div>
                <div className="comp_bottom_left">
                  <p className="comp_text_para">2025</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="recent_customerwin_subblock">
              <h5 className="recent_customerwin_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="recent_customerwin_para">
                Signed a prime vendor agreement covering multiple member
                organizations, including pediatric hospice; {competitorName ?? 'Tailored Chemical Products'} to supply
                clinical kits and products
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_yellow">
                    Hospice / Post-Acute
                  </a>
                </div>
                <div className="comp_bottom_left">
                  <p className="comp_text_para">2025</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="recent_customerwin_subblock">
              <h5 className="recent_customerwin_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="recent_customerwin_para">
                Signed a prime vendor agreement covering multiple member
                organizations, including pediatric hospice; {competitorName ?? 'Tailored Chemical Products'} to supply
                clinical kits and products
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_yellow">
                    Hospice / Post-Acute
                  </a>
                </div>
                <div className="comp_bottom_left">
                  <p className="comp_text_para">2025</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <CustomerSegmentsAndUseCases />
      <TrendingCompetitors /> */}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Strategic Analysis"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default ProfileMarketPosition;
